import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'
import { CreatePlaylistDTO, Playlist } from './playlistsSlice'
import { CreateFolderDTO, EditFolderDTO, GetFoldersListDto, PlaylistFolder } from './moodsSlice'

type StyleId = string
interface State {
  styles: Record<StyleId, PlaylistFolder>
}

export const initialState: State = {
  styles: {},
}
export const attemptCreateStyle = createAsyncThunk<PlaylistFolder, CreateFolderDTO>(
  'styles/style-create',
  async (payload) => {
    const response = await $api.post(`styles/create`, payload)
    return response.data
  },
)

export const attemptGetStylesList = createAsyncThunk<PlaylistFolder[], GetFoldersListDto>(
  'styles/list',
  async (payload) => {
    const response = await $api.post('styles/admin/list', payload)
    return response.data
  },
)

export const attemptGetStyle = createAsyncThunk<PlaylistFolder, string>(
  'styles/get-style',
  async (id) => {
    const response = await $api.post(`styles/get/${id}`)

    return response.data
  },
)

export const attemptEditStyle = createAsyncThunk<void, EditFolderDTO>(
  'styles/style-edit',
  async (payload) => {
    const response = await $api.post(`styles/update/${payload._id}`, payload)
    return
  },
)

export const attemptDeleteStyle = createAsyncThunk<
  PlaylistFolder['_id'],
  PlaylistFolder['_id']
>('styles/style-delete', async (id) => {
  await $api.post(`styles/delete/${id}`)
  return id
})

export const stylesReducer = createSlice({
  name: 'styles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptCreateStyle.fulfilled, (state, { payload }) => {
      // state.styles[payload._id] = payload //don't need it as we are always fetching styles when coming to the page
    })
    builder.addCase(attemptGetStylesList.fulfilled, (state, { payload }) => {
      payload.forEach((playlist) => {
        state.styles[playlist._id] = playlist
      })
    })
    builder.addCase(attemptDeleteStyle.fulfilled, (state, { payload: _id }) => {
      delete state.styles[_id]
    })
  },
})

export const {} = stylesReducer.actions
export default stylesReducer.reducer
